/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import SectionTop from '../layout/SectionTop';
import Why2Bytes from '../layout/Why2Bytes';
import SectionBottom from '../layout/SectionBottom';

import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';

import { Box as div } from '@mui/material';

import bg_cm_step1 from '../resources/images/bg_cm_step1.png';
import bg_cm_step2 from '../resources/images/bg_cm_step2.png';
import bg_cm_step3 from '../resources/images/bg_cm_step3.png';
import bg_cm_step4 from '../resources/images/bg_cm_step4.png';
import bg_cm_step5 from '../resources/images/bg_cm_step5.png';
import bg_cm_step6 from '../resources/images/bg_cm_step6.png';

const CssCenter = css`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const CssItem = css`
  position: relative;
  background-color: #f5f5fb;
  height: 90px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 1.6rem;
  text-align: center;
  @media (max-width: 992px) {
    font-size: 1.1rem;
    height: 56px;
  }
`;
const CssItemAfter = css`
  margin-bottom: 80px;
  @media (max-width: 992px) {
    margin-bottom: 100px;
  }
  &::after {
    position: absolute;
    content: '';
    border: none;
    border-right: 5px dotted #c6b2d7;
    /* background: url(data:image/png;base64,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) repeat-y left top; */
    width: 6px;
    height: 76px;
    transform: translateY(calc(100% + 1rem));
  }
`;
const CssItemBefore = css`
  margin-top: calc(80px + 1rem);
  @media (max-width: 992px) {
    margin-top: calc(100px + 1rem);
  }
  &::before {
    position: absolute;
    content: '';
    border: none;
    border-right: 5px dotted #c6b2d7;
    /* background: url(data:image/png;base64,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) repeat-y left top; */
    width: 6px;
    height: 76px;
    transform: translateY(-100%);
  }
`;

function SvgMarketingProcess() {
  const { t, i18n } = useTranslation();
  const pt = (v) => parse(i18n.t(v));
  
  return (
    <>
      {/* <svg
        xmlns="http://www.w3.org/2000/svg"
        ref={svgRef}
        viewBox="0 0 1060 483"
        fill="none"
        css={css`
          min-width: fit-content;
          max-width: 1060px;
          height: 100%;
          text {
            text-anchor: middle;
            dominant-baseline: middle;
          }
        `}
      >
        <rect width="1060" height="483" fill="#E5E5E5" />
        <rect
          width="1920"
          height="7432"
          transform="translate(-430 -1730)"
          fill="white"
        />

        <rect
          width="243"
          height="56"
          transform="translate(409 427)"
          fill="#743FA3"
        />
        <text
          fill="white"
          space="preserve"
          style={{ fontSize: '2rem', fontWeight: 'bold' }}
        >
          <tspan x={409 + 243 / 2} y={427 + 56 / 2}>
            {t('SvgMarketingProcess_1')}
          </tspan>
        </text>

        <rect x="528" y="342" width="5" height="76" fill="url(#pattern1)" />

        <rect width="160" height="90" fill="#F5F5FB" />
        <text
          fill="#444444"
          space="preserve"
          style={{
            fontSize: '1.7rem',
            letterSpacing: '-1px'
          }}
        >
          <tspan x={160 / 2} y={90 / 2}>
            {t('SvgMarketingProcess_2')}
          </tspan>
        </text>

        <rect
          width="160"
          height="90"
          transform="translate(180)"
          fill="#F5F5FB"
        />
        <text
          fill="#444444"
          space="preserve"
          style={{
            fontSize: '1.7rem',
            letterSpacing: '-1px'
          }}
        >
          <tspan x={180 + 160 / 2} y={90 / 2}>
            {t('SvgMarketingProcess_3')}
          </tspan>
        </text>

        <rect
          width="160"
          height="90"
          transform="translate(360)"
          fill="#F5F5FB"
        />
        <text
          fill="#444444"
          space="preserve"
          style={{
            fontSize: '1.7rem',
            letterSpacing: '-1px'
          }}
        >
          <tspan x={360 + 160 / 2} y={90 / 2}>
            {t('SvgMarketingProcess_4')}
          </tspan>
        </text>

        <rect
          width="160"
          height="90"
          transform="translate(540)"
          fill="#F5F5FB"
        />
        <text
          fill="#444444"
          space="preserve"
          style={{
            fontSize: '1.7rem',
            letterSpacing: '-1px'
          }}
        >
          <tspan x={540 + 160 / 2} y={90 / 2}>
            {t('SvgMarketingProcess_5')}
          </tspan>
        </text>

        <rect
          width="160"
          height="90"
          transform="translate(720)"
          fill="#F5F5FB"
        />
        <text
          fill="#444444"
          space="preserve"
          style={{
            fontSize: '1.7rem',
            letterSpacing: '-1px'
          }}
        >
          <tspan x={720 + 160 / 2} y={90 / 2}>
            {t('SvgMarketingProcess_6')}
          </tspan>
        </text>

        <rect
          width="160"
          height="90"
          transform="translate(900)"
          fill="#F5F5FB"
        />
        <text
          fill="#444444"
          space="preserve"
          style={{
            fontSize: '1.7rem',
            letterSpacing: '-1px'
          }}
        >
          <tspan x={900 + 160 / 2} y={90 / 2}>
            {t('SvgMarketingProcess_7')}
          </tspan>
        </text>

        <rect x="530" y="192" width="5" height="76" fill="url(#pattern1)" />
        <rect x="76" y="99" width="5" height="76" fill="url(#pattern1)" />
        <rect
          x="76"
          y="186"
          width="5"
          height="910"
          transform="rotate(-90 76 186)"
          fill="url(#pattern3)"
        />
        <rect x="438" y="99" width="5" height="76" fill="url(#pattern1)" />
        <rect x="618" y="99" width="5" height="76" fill="url(#pattern1)" />
        <rect x="798" y="99" width="5" height="76" fill="url(#pattern1)" />
        <rect x="979" y="99" width="5" height="76" fill="url(#pattern1)" />
        <rect x="258" y="99" width="5" height="76" fill="url(#pattern1)" />

        <rect
          width="243"
          height="56"
          transform="translate(409 277)"
          fill="#F5F5FB"
        />
        <text
          fill="#444444"
          style={{
            fontSize: '17',
            letterSpacing: '-1px'
          }}
        >
          <tspan x={409 + 243 / 2} y={277 + 56 / 2}>
            {t('SvgMarketingProcess_8')}
          </tspan>
        </text>

        <defs>
          <pattern
            id="pattern1"
            patternContentUnits="objectBoundingBox"
            width="1"
            height="3.39474"
          >
            <use href="#image0_547_1494" transform="scale(0.2 0.0131579)" />
          </pattern>
          <pattern
            id="pattern3"
            patternContentUnits="objectBoundingBox"
            width="1"
            height="0.283516"
          >
            <use href="#image0_547_1494" transform="scale(0.2 0.0010989)" />
          </pattern>

          <image
            id="image0_547_1494"
            width="5"
            height="258"
            href="data:image/png;base64,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"
          />
        </defs>
      </svg> */}

      <div
        id="flowchat"
        css={css`
          display: flex;
          flex-direction: column;
        `}
      >
        <div
          css={css`
            width: 100%;
            display: grid;
            grid-template-columns: repeat(6, 1fr);
            flex-direction: row;
            gap: 2rem;

            @media (max-width: 992px) {
              gap: 0.4rem;
            }
          `}
        >
          <div css={[CssItem, CssItemAfter]}>{t('SvgMarketingProcess_2')}</div>
          <div css={[CssItem, CssItemAfter]}>{t('SvgMarketingProcess_3')}</div>
          <div css={[CssItem, CssItemAfter]}>{t('SvgMarketingProcess_4')}</div>
          <div css={[CssItem, CssItemAfter]}>{t('SvgMarketingProcess_5')}</div>
          <div css={[CssItem, CssItemAfter]}>{t('SvgMarketingProcess_6')}</div>
          <div css={[CssItem, CssItemAfter]}>{t('SvgMarketingProcess_7')}</div>
        </div>
        <div
          css={css`
            border: none;
            border-bottom: 5px dotted #c6b2d7;

            margin-left: calc(100% / 6 / 2);
            margin-right: calc(100% / 6 / 2);
            transform: translateX(0.4rem);
            @media (max-width: 1280px) {
              transform: translateX(0.5rem);
            }
            @media (max-width: 992px) {
              transform: translateX(0.3rem);
            }
          `}
        />
        <div css={CssCenter}>
          <div
            css={[
              CssItem,
              CssItemBefore,
              css`
                font-weight: 500;
                height: 56px;
                width: 243px;
                @media (max-width: 992px) {
                  width: 152px;
                  height: 40px;
                }
              `
            ]}
          >
            {t('SvgMarketingProcess_8')}
          </div>
        </div>
        <div css={CssCenter}>
          <div
            css={[
              CssItem,
              CssItemBefore,
              css`
                height: 56px;
                background-color: #743fa3;
                color: white;
                font-weight: 700;
                width: 243px;
                @media (max-width: 992px) {
                  width: 152px;
                  height: 40px;
                }

              `
            ]}
          >
            {t('SvgMarketingProcess_1')}
          </div>
        </div>
      </div>
    </>
  );
}

function Content() {
  const { t, i18n } = useTranslation();
  const pt = (v) => parse(i18n.t(v));

  useEffect(() => {
    $(window).trigger('scroll');
    $(window).scrollTop(0);
  }, []);
  return (
    <>
      <section className="section_discript">
        <div className="inner">
          <strong className="title">{pt('ContentMarketing_2')}</strong>

          <div className="step_box">
            <dl>
              <dt>
                <span className="num">1</span>
                {pt('ContentMarketing_3')}
              </dt>
              <dd>{pt('ContentMarketing_4')}</dd>
            </dl>
            <dl>
              <dt>
                <span className="num">2</span>
                {pt('ContentMarketing_5')}
              </dt>
              <dd>{pt('ContentMarketing_6')}</dd>
            </dl>
            <dl>
              <dt>
                <span className="num">3</span>
                {pt('ContentMarketing_7')}
              </dt>
              <dd>{pt('ContentMarketing_8')}</dd>
            </dl>
          </div>
        </div>
      </section>

      <section className="section_discript">
        <div className="h_title_box inner">
          <h3 className="h_title">{pt('ContentMarketing_9')}</h3>
          <p className="desc">{pt('ContentMarketing_10')}</p>
        </div>

        <div className="inner">
          {/* <div
            style={{
              display: 'flex',
              justifyContent: 'center'
            }}
          >
          </div> */}
          <SvgMarketingProcess />
        </div>
      </section>

      <section className="section_player">
        <div className="text_box">
          <div className="inner d_table">
            <div className="d_cell text_primary">
              {pt('ContentMarketing_11')}
            </div>
            <div className="d_cell btn_area">
              <a
                href={`/${i18n.language}/Contact`}
                className="btn_basic btn_primary btn_xl btn_pop_open"
              >
                {pt('ForStages_20')}
                {/* 문의/업무의뢰 */}
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="section_progress">
        <div className="inner">
          <div className="h_title_box" style={{ marginBottom: '9rem' }}>
            <h3 className="h_title">{pt('ContentMarketing_12')}</h3>
          </div>

          <ol className="step_list_wrap">
            {/* step1 */}
            <li className="left step1">
              <div className="h_title_box">
                <strong className="h_title">
                  <div
                    className="num"
                    sx={{
                      fontSize: 'unset',
                      textIndent: 'unset',
                      fentWeight: 500,
                      '&::before': { display: 'none' },
                      '&::after': { display: 'none' }
                    }}
                  >
                    1
                  </div>
                  {pt('ContentMarketing_13')}
                </strong>
              </div>

              <div className="step_cont">
                <p className="text">{pt('ContentMarketing_14')}</p>
              </div>

              <div className="bottom_line"></div>
            </li>

            {/* step2 */}
            <li className="right step2">
              <div className="h_title_box">
                <strong className="h_title">
                  <div
                    className="num"
                    sx={{
                      fontSize: 'unset',
                      textIndent: 'unset',
                      fentWeight: 500
                    }}
                  >
                    2
                  </div>
                  {pt('ContentMarketing_15')}
                </strong>
              </div>

              <div className="step_cont">
                <p className="text">{pt('ContentMarketing_16')}</p>
              </div>
              <div className="bottom_line"></div>
            </li>

            <li className="left step3">
              <div className="h_title_box">
                <strong className="h_title">
                  <div
                    className="num"
                    sx={{
                      fontSize: 'unset',
                      textIndent: 'unset',
                      fentWeight: 500
                    }}
                  >
                    3
                  </div>
                  {pt('ContentMarketing_17')}
                </strong>
              </div>

              <div className="step_cont">
                <p className="text">{pt('ContentMarketing_24')}</p>
              </div>

              <div className="bottom_line"></div>
            </li>

            {/* step4 */}
            <li className="right step4">
              <div className="h_title_box">
                <strong className="h_title">
                  <div
                    className="num"
                    sx={{
                      fontSize: 'unset',
                      textIndent: 'unset',
                      fentWeight: 500
                    }}
                  >
                    4
                  </div>
                  {pt('ContentMarketing_18')}
                </strong>
              </div>

              <div className="step_cont">
                <p className="text">{pt('ContentMarketing_19')}</p>
              </div>
              <div className="bottom_line"></div>
            </li>

            <li className="left step5">
              <div className="h_title_box">
                <strong className="h_title">
                  <div
                    className="num"
                    sx={{
                      fontSize: 'unset',
                      textIndent: 'unset',
                      fentWeight: 500
                    }}
                  >
                    5
                  </div>
                  {pt('ContentMarketing_20')}
                </strong>
              </div>

              <div className="step_cont">
                <p className="text">{pt('ContentMarketing_21')}</p>
              </div>

              <div className="bottom_line"></div>
            </li>

            <li className="right step6 last">
              <div className="h_title_box">
                <strong className="h_title">
                  <div
                    className="num"
                    sx={{
                      fontSize: 'unset',
                      textIndent: 'unset',
                      fentWeight: 500
                    }}
                  >
                    6
                  </div>
                  {pt('ContentMarketing_22')}
                </strong>
              </div>

              <div className="step_cont">
                <p className="text">{pt('ContentMarketing_23')}</p>
              </div>
              <div className="bottom_line last"></div>
            </li>
          </ol>
        </div>
      </section>
    </>
  );
}

function PlayerSupport(props) {
  return (
    <div id="container" className="cont_cm">
      <SectionTop title="Content Marketing" mtitle="CM" />
      <Content />
      <Why2Bytes />
      <SectionBottom />
    </div>
  );
}

export default PlayerSupport;
